import { Link } from '@tanstack/react-router';
import { useBottomNavProps } from '@/shared/layout/bottom-nav/hooks';
import type { BottomNavProps } from '@/shared/layout/bottom-nav/types';
import { resolveIcon } from '@/shared/layout/icon-registry';

export function BottomNav(props: BottomNavProps) {
  const { navProps, items, profileSlot } = useBottomNavProps(props);

  return (
    <nav {...navProps}>
      {items.map((item) => {
        const Icon = resolveIcon(item.icon);
        return (
          <Link key={item.to} to={item.to} {...item.linkProps}>
            {Icon ? <Icon className="h-5 w-5" aria-hidden="true" /> : null}
            <span>{item.label}</span>
          </Link>
        );
      })}
      {profileSlot}
    </nav>
  );
}

export { useBottomNavProps } from '@/shared/layout/bottom-nav/hooks';
export type { BottomNavProps } from '@/shared/layout/bottom-nav/types';
